module.exports = __webpack_public_path__ + "img/deposit_maintenance.70537f25.png";